import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";
import WGRTable from "./uocTable";


//import WGRTotals from "./iohTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
   const totals = useMemo(() => {




    return rows.reduce(
      (total, row) => ({
        A:
          total.A +
          Number(row["U/O CHARGE LABOUR ON COST (A)"] || 0),

        B:
          total.B +
          Number(row["ENGA - TIMESHEET(B)"] || 0),

           C:
          total.C +
          Number(row["TOTAL OF A+B"] || 0),

        D:
          total.D +
          Number(row["U/O ON COST STORE"] || 0),

          

         

         }),

        
          

      {
        A: 10,
        B: 0,
        C: 0,
        D: 0,
       
      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >
      
   <WGRTable
  rows={rows}
  shop={shop}
  totals={totals}
  showTotal={true}
/>
      
        
    </Paper>
  );
}

